import { render, staticRenderFns } from "./staffpaidslip.vue?vue&type=template&id=6bde4bfe&"
import script from "./staffpaidslip.vue?vue&type=script&lang=js&"
export * from "./staffpaidslip.vue?vue&type=script&lang=js&"
import style0 from "./staffpaidslip.vue?vue&type=style&index=0&id=6bde4bfe&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports